"use strict";var e=require("../Constant/MessageType.cjs");exports.humaniseMessageType=function(s){switch(s){case e.MessageType.INFO:return"INFO";case e.MessageType.LOG:return"LOG";case e.MessageType.WARNING:return"WARNING";case e.MessageType.ERROR:return"ERROR"}};
//# sourceMappingURL=humaniseMessageType.cjs.map
